<template>
	<section>
		<div class="upload-header">
			<h2>
				{{ title }}
			</h2>
			<button v-if="allowedToUpload" :disabled="disabled === true" type="button"
					@click="$refs.uploadInput.click()">
				<PlusIcon/>
			</button>
		</div>
		<input
			v-if="allowedToUpload && !disabled"
			class="upload-input"
			type="file"
			:multiple="multiple"
			@change="addFiles($event.target.files)"
			ref="uploadInput"
			:accept="accept"
		>
		<div class="files">
			<div v-for="(file, index) in pendingFiles" class="preview image">
				<button
					v-if="file.state === 'pending'"
					class="delete-button"
					type="button"
					@click="pendingFiles.splice(index, 1)"
				>
					<XIcon/>
				</button>
				<loading-indicator class="loader" v-if="file.state === 'uploading'"></loading-indicator>
				<img :src="file.getThumbnail()">
			</div>
			<a :href="'/files/getById?file_id=' + file.id" target="_blank" v-for="(file, index) in files" class="image">
				<img :src="'/files/getById?height=200&width=200&file_id=' + file.id" :alt="file.file_name">
			</a>
		</div>
	</section>
</template>

<script>
import {QueuedFile} from "@/common/queued-file";
import LoadingIndicator from "@/components/LoadingIndicator";
import {PlusIcon, XIcon} from "vue-feather-icons";
import {mapActions, mapGetters} from "vuex";

export default {
	components: {
		LoadingIndicator,
		PlusIcon,
		XIcon
	},
	data() {
		return {
			pendingFiles: [],
			files: [],
			allowedToUpload: false,
			loadedCompanyId: ""
		};
	},

	props: {
		title: {
			type: String,
			default: ""
		},
		type: {
			type: String,
			default: ""
		},
		companyId: {
			default: ""
		},
		multiple: {
			type: Boolean,
			default: true
		},
		accept: {
			type: String,
			default: "*/*"
		},
		disabled: {
			type: Boolean,
			default: false
		},
		startUpload: {
			type: Boolean,
			default: false
		}
	},

	mounted() {
		if(this.loadedCompanyId !== this.companyId) {
			this.getFiles();
		}
		this.allowedToUpload = this.allowedTo("files/add");
	},

	watch: {
		startUpload: function (newValue) {
			if (newValue) {
				this.uploadFiles();
			}
		},
		companyId: function (newValue) {
			if(this.loadedCompanyId === this.companyId) {
				return;
			}
			this.getFiles();
		}
	},

	methods: {
		...mapActions({
			fetchFiles: "files/fetchFiles"
		}),
		...mapGetters({
			allowedTo: 'auth/allowedTo',
		}),

		getFiles() {
			this.loadedCompanyId = this.companyId;
			this.fetchFiles({
				type: this.type,
				company_id: this.companyId
			}).then(response => {
				this.files = response;
			});
		},

		addFiles(files) {
			if (this.disabled || this.allowedToUpload === false) {
				return;
			}
			for (const file of files) {
				this.pendingFiles.push(new QueuedFile(file, this.type, this.companyId, this.$forceUpdate));
			}
			this.$refs.uploadInput.value = "";
		},

		uploadFiles() {
			if (this.disabled) {
				return;
			}
			for (const file of this.pendingFiles) {
				file.upload().then(() => {
					this.pendingFiles.splice(this.pendingFiles.indexOf(file), 1);
					this.getFiles();
				});
			}
		}
	}
};
</script>

<style scoped>
.upload-header {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 100%;
}

.upload-header h2 {
	margin: 0.3em 0;
}

.upload-header button {
	border: 2px solid #35a5a4;
	color: #35a5a4;
	background-color: #8dd7cf;
	border-radius: 0;
}

.upload-input {
	visibility: hidden;
	display: none;
}

.files {
	display: flex;
	flex-direction: row;
	gap: 8px;
	overflow-x: auto;
	overflow-y: hidden;
	max-height: 150px;
	margin-top: 8px;
}

.image {
	height: 100px;
	width: 100px;
	min-width: 100px;
	min-height: 100px;
	position: relative;
}

.delete-button {
	position: absolute;
	right: 0;
	top: 0;
	z-index: 1;
	color: white;
	background-color: #e53935;
	border: none;
}

.image img {
	height: 100%;
	width: 100%;
	object-fit: cover;
}

.preview img {
	filter: contrast(0.5);
}

.preview .loader {
	z-index: 2;
	width: 90%;
	height: 90%;
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	margin: auto;
}

</style>
